import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/29_card_back_swan/29_card_back_swan"
 * Contains 1 texture(s)
 */
export class CardsBacks29CardBackSwanAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/29_card_back_swan/29_card_back_swan';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '29_swan.png'
    ] as const;
}
